import { NgClass } from '@angular/common'
import { Component, input } from '@angular/core'
import { DELIVERY_HELP_ASSETS, DeliveryHelpContent, DeliveryPathLink, DeliveryPathNode, PathLabelTone } from '../../../../../helpers/delivery-status-help'

@Component({
  selector: 'app-delivery-flow-chain',
  standalone: true,
  imports: [NgClass],
  templateUrl: './delivery-flow-chain.component.html',
  styleUrl: './delivery-flow-chain.component.scss'
})
export class DeliveryFlowChainComponent {
  public readonly path = input.required<DeliveryHelpContent['path']>()
  public readonly assets = DELIVERY_HELP_ASSETS

  private readonly _nodeIconByType: Record<Exclude<DeliveryPathNode['type'], 'brand'>, string> = {
    mailServer: this.assets.mailServer,
    mobileOperator: this.assets.mobileOperator,
    meta: this.assets.meta,
    recipient: this.assets.recipient
  }

  private readonly _toneClassByTone: Record<PathLabelTone, string> = {
    neutral: 'tw-text-gray-500',
    success: 'tw-text-green-600',
    danger: 'tw-text-red-600'
  }

  /**
   * Returns the icon for a node.
   * @param type - The type of the node.
   * @returns The icon for the node.
   */
  nodeIcon(type: Exclude<DeliveryPathNode['type'], 'brand'>): string {
    return this._nodeIconByType[type]
  }

  /**
   * Returns the class name for a tone.
   * @param tone - The tone.
   * @returns The class name for the tone.
   */
  toneClass(tone: PathLabelTone | undefined): string {
    return this._toneClassByTone[tone ?? 'neutral']
  }

  /**
   * Returns the link at an index.
   * @param index - The index of the link.
   * @returns The link at the index.
   */
  linkAt(index: number): DeliveryPathLink | undefined {
    return this.path().links[index]
  }

  /**
   * Returns whether a link has a reverse arrow.
   * @param link - The link.
   * @returns Whether the link has a reverse arrow.
   */
  hasReverseArrow(link: DeliveryPathLink): boolean {
    return !!link.reverseLabel
  }

  /**
   * Returns the source of the reverse arrow.
   * @param link - The link.
   * @returns The source of the reverse arrow.
   */
  reverseArrowSrc(link: DeliveryPathLink): string {
    return link.reverseTone === 'danger' ? this.assets.arrowLeftRed : this.assets.arrowLeftGreen
  }
}
